// extracted by mini-css-extract-plugin
export default {"modalContainer":"Popup_modalContainer__F4cNX","modalHeading":"Popup_modalHeading__NZtbq","scrollBox":"Popup_scrollBox__KYWv5","btnContainer":"Popup_btnContainer__4tDRt"};